import styled from 'styled-components';

const DetailsWrapper = styled.div`
  max-width: 670px;
  margin: 0 auto;
  .message-types-row {
    padding: 1.5em 1em .5em;  
    display: flex;
    align-items: center;
    justify-content: space-between;
    >label {
      width: initial;
      min-width: 25%;
    }    
  }
  .section {
    background-color: ${p => p.theme.color.bg_white};
    transition: all .25s .25s ease-in-out;
    overflow: hidden;
    padding-top: 0;
    padding-bottom: 0;
    &:last-of-type {
      border-bottom: 1px solid ${p => p.theme.color.border};
    }
    >*:last-child {
      margin-bottom: 1em
    }
    &.collapsed {
      max-height: 0;
      opacity: 0;
    }
    &.expanded {
      max-height: 500px;
      opacity: 1;
    }
  }
  .chart-counter {
    color: ${p => p.theme.color.primary};
    font-size: 0.75em;
    position: relative;
    margin: 0 .1em;
    text-align: right;
    &.error {
      color: ${p => p.theme.color.error};
    }    
  }
  .positioner-wrapper {
    position: relative;
    .section {
      border-bottom-color: transparent;      
    }
    .show-border-bottom {
      border-bottom-color: ${p => p.theme.color.border};
    }
  }
  .inform-block {
    margin-top: 1em;
  }
  .empty-warning { 
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    box-sizing: border-box;
    z-index: -1;
    transition: opacity .2s ease-in-out;
    opacity: 0;
    &.show {
      opacity: 1
    }
    h1 {
      color: ${p => p.theme.color.label};
      font-weight: normal;
      text-align: center;
    }
  }
`;

export default { DetailsWrapper };